import styled from "styled-components"
import { skippedOpacity } from "./ExecutionOverlay.styled"
import { BranchKind, THEN } from "../../branchKind"

export const NodeContainer = styled.div<{ $skipped?: boolean }>`
  position: relative;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${p => p.theme.colors.workflows.condition};
  border-radius: 0.8rem;
  width: 22rem;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);
  ${skippedOpacity}
`

export const NodeHeader = styled.div`
  background: ${p => p.theme.colors.workflows.condition};;
  color: ${(p) => p.theme.colors.white};
  padding: 0.6rem 1.2rem;
  border-radius: 0.8rem 0.8rem 0 0;
  margin: -0.1rem -0.1rem 0 -0.1rem;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  ${(p) => p.theme.bold};
`

export const NodeBody = styled.div`
  padding: 1rem 1.2rem;
  font-size: 1.3rem;
  ${(p) => p.theme.bold};
`

export const CheckInfo = styled.div`
  padding: 0 1.2rem 0.8rem;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
`

/** Branch label pill anchored to the condition's source handle. Rendered
 *  once per branch, directly on the node — independent of how many child
 *  edges fan out and whether the "+ Add" terminal button is shown. */
export const BranchLabelPill = styled.div<{ $variant: BranchKind }>`
  position: absolute;
  bottom: -2.6rem;
  transform: translateX(-50%);
  pointer-events: none;
  padding: 0.25rem 0.9rem;
  border-radius: 1rem;
  font-size: 0.95rem;
  line-height: 1;
  ${(p) => p.theme.bold};
  text-transform: uppercase;
  letter-spacing: 0.08rem;
  color: ${(p) => p.theme.colors.white};
  background: ${(p) => (p.$variant === THEN ? "#10b981" : "#ef4444")};
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.12);
  white-space: nowrap;
`
